import $ from 'jquery'
import Backbone from 'backbone'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import template from './group-cascade-dialog.hbs'

const GroupDialog = Backbone.View.extend({

	className: 'group-cascade-dialog',

	tagName: 'form',

	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		const {groupId, orgId, cascade} = this.options
		this.$el.empty().append(template({cascade}))

		this.formView = new FormView({
			el: this.el,
			submit: () => {
				const {cascade = false} = formHelper.readFromDom(this.el)
				$.ajax({
					method: 'PUT',
					url: `api/admin/groups/${groupId}/organizations/${orgId}`,
					data: JSON.stringify({groupId, cascade}),
					success: () => this.trigger('done'),
					error: xhr => this.formView.error(xhr)
				})
			}
		})
		this.formView.start()

		return this
	}
})

export default GroupDialog

GroupDialog.__filename__ = 'admin/principals/groups/group-cascade-dialog.js'
